<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <signup-card>
            <h2 class="title text-center" slot="title">Register</h2>
            <div
              class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 ml-auto logo-main"
              slot="content-left"
            >
              <img :src="logo" alt="">
            </div>

            <div
              class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 mr-auto register-inputs"
              slot="content-right"
            >
            <ValidationProvider
              name="required"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field class="md-form-group" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                <md-icon>face</md-icon>
                <label>First Name</label>
                <md-input v-model="first_name" type="text"></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
           </ValidationProvider>
           <ValidationProvider
             name="required"
             rules="required"
             v-slot="{ passed, failed }"
           >
             <md-field class="md-form-group" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
               <md-icon>face</md-icon>
               <label>Last Name</label>
               <md-input v-model="last_name" type="text"></md-input>
               <slide-y-down-transition>
                 <md-icon class="error" v-show="failed">close</md-icon>
               </slide-y-down-transition>
               <slide-y-down-transition>
                 <md-icon class="success" v-show="passed">done</md-icon>
               </slide-y-down-transition>
             </md-field>
          </ValidationProvider>
            <ValidationProvider
              name="email"
              rules="required|email"
              v-slot="{ passed, failed }"
            >
              <md-field class="md-form-group" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                <md-icon>email</md-icon>
                <label>Email</label>
                <md-input v-model="email" type="email"></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
            <ValidationProvider
              name="password"
              rules="required|min:6"
              v-slot="{ errors, passed, failed }"
            >
              <md-field class="md-form-group" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                <md-icon>lock_outline</md-icon>
                <label>Password</label>
                <md-input v-model="password" type="password"></md-input>
                <span class="md-helper-text"
                  >Your password should be 6 characters long.</span
                >
                <!-- <span class="md-helper-text"
                  >{errors}</span
                > -->
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
            <ValidationProvider
              vid="confirmation"
              rules="required|confirmed:password"
              v-slot="{ passed, failed }"
            >
              <md-field class="md-form-group" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                <md-icon>lock_outline</md-icon>
                <label>Retype Password</label>
                <md-input
                  v-model="password_confirmation"
                  type="password"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
            <div class="errors" v-if="errors.length && !inviteResent">
              {{errors}}
              <p v-if="pendingLink" v-on:click="resendLink" class="errlink">Please check to see if you have an invitation to SafeCore in your inbox. If you cannot find the invitation email in your inbox, click here to get it resent.</p>
            </div>
            <div v-if="inviteResent">
              A new invitation has been sent to {{email}}, please check it again
            </div>
                <p class="terms md-helper-text" v-if="termsFailed">Please agree to the terms and conditions before preceeding.</p>
                <md-checkbox v-model="terms" >
                  I agree to the <a v-on:click="showTerms">terms and conditions</a>.
                </md-checkbox>
                <div class="dialog-wrapper">
                  <md-dialog :md-active.sync="showDialog">
                    <md-dialog-title>Terms and Conditions</md-dialog-title>
                    <TermsModal />
                  </md-dialog>
                </div>

              <div class="button-container">
                <md-button class="md-success md-round mt-4" slot="footer" type="submit">
                  Get Started
                </md-button>
              </div>
            </div>
          </signup-card>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { SignupCard } from "@/components";
import { mapActions, mapState } from "vuex";
import axios from "axios";
import api from "@/api";
import store from "@/store";
import { extend } from "vee-validate";
import { required, email, confirmed, min } from "vee-validate/dist/rules";
import TermsModal from "@/pages/Dashboard/UserPages/Components/TermsModal.vue";

extend("email", email);
extend("required", required);
extend("confirmed", confirmed);
extend("min", min);


export default {
  components: {
    SignupCard,
    TermsModal
  },
  props: {
    logo: {
      type: String,
      default: "./img/mainscs_logo.png"
    },
  },
  data() {
    return {
      showDialog: false,
      freetrialimg: "./img/30_day_icon.png",
      minLength: "",
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      password_confirmation: "",
      typeOfAcc: true,
      license: "",
      cGoldLs: "",
      cSilverLs: "",
      submitted: false,
      boolean: false,
      terms: false,
      termsFailed: false,
      pendingInvite: false,
      inviteResent: false,
      contentLeft: [
        {
          colorIcon: "icon-info",
          icon: "book",
          title: "Silver License",
          description:
            "$99/Year Read only access to Safe Core Systems projects."
        },

        {
          colorIcon: "icon-info",
          icon: "storage",
          title: "Gold License",
          description: "1,000/Year All access to Safe Core Systems projects"
        },
        {
          colorIcon: "icon-info",
          icon: "people_alt",
          title: "Corporate Licensing",
          description:
            "Choose as many silver and gold licenses as you need for your company."
        }
      ],
      inputs: [
        {
          icon: "face",
          name: "Full Name",
          nameAttr: "first_name",
          type: "text"
        },

        {
          icon: "email",
          name: "Email...",
          nameAttr: "email",
          type: "email"
        },

        {
          icon: "lock_outline",
          name: "Password..",
          nameAttr: "password",
          type: "password"
        },
        {
          icon: "lock_outline",
          name: "Retype Password..",
          nameAttr: "password_confirmation",
          type: "password"
        }
      ],
      errors: []
    };
  },
  methods: {
    showTerms() {
      this.showDialog = !this.showDialog;
    },
    resendLink(){
      var u = {
        email: this.email
      }
      console.log('in resend')
      api.resendInvite(u).then((response) => {
        console.log(response)
        this.inviteResent = true;
      })
    },
    signUp() {
      this.inviteResent = false;
      this.pendingLink = false;
        this.$store
          .dispatch("signUp", {
            user: {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
            }
          })
          .then(() => {
            this.errors = {};
            this.$router.push("confirmemail");
          })
          .catch(errors => {
            this.errors = errors;
            this.errors = this.errors.join(' ');
            if (this.errors.toLowerCase().includes('taken')) {this.pendingLink = true}
          });
      },
      onSubmit() {
        console.log('hello');
        if (this.terms) {
          this.termsFailed = false;
          this.signUp();
        } else {
          this.termsFailed = true;
        }
      }
    },
  }
</script>
<style lang="scss">
.md-radio-select {
  label {
    top: 0;
  }
  ::before {
    display: none;
  }
}
.free-trial-info {
  // display: flex;
  // justify-content: flex-start;
  // align-items: flex-start;
  .img-wrap {
    display: flex;
    justify-content: center;
    img {
      width: 60%;
      padding-top: 15px;
      margin: 0 auto;
    }
  }
  p {
    width: 100%;
    padding: 5px;
    padding-left: 10px;
    // font-size: 13px;
    text-align: center;
  }
}
.reg-spacer {
  width: 100%;
  height: 40px;
}
</style>
